module.exports = __webpack_public_path__ + "img/mobile.23d9942d.svg";